import { useState, useEffect } from 'react';
import { TaglineService, PromptBoxInstructions } from '../services/taglineService';

/**
 * Hook to fetch prompt box instruction text from Firestore
 * Returns instructions for both in-conversation and new conversation states
 */
export function usePromptBoxInstructions() {
  const [instructions, setInstructions] = useState<PromptBoxInstructions>({
    inConversation: 'add context to this conversation',
    newConversation: 'conversations better than with any lone AI chatbot start here...',
    helpmestartPostscriptIntro: 'postscript: the user-generated language above was authored in context of the following:',
    customreviewPostscriptIntro: 'postscript. generate an excellent response to the above prompt as defined by the following rubric:'
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isMounted = true;

    const fetchInstructions = async () => {
      try {
        setLoading(true);
        const data = await TaglineService.getPromptBoxInstructions();
        
        if (isMounted) {
          setInstructions(data);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError(err as Error);
          console.error('Failed to fetch prompt box instructions:', err);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchInstructions();

    return () => {
      isMounted = false;
    };
  }, []);

  return { instructions, loading, error };
}



